<template>
	<div style="overflow: hidden;"
		:style="{'background':data.config.containerBgColor ||'','border-radius':data.config.borderRadius+'px','color':data.config.titleColor ||'','marginTop': data.config.marginTop+'px','marginRight': data.config.marginRight+'px', 'marginBottom': data.config.marginBottom+'px','marginLeft': data.config.marginLeft+'px','paddingTop': data.config.paddingTop+'px','paddingBottom': data.config.paddingBottom+'px','paddingLeft': data.config.paddingLeft+'px','paddingRight': data.config.paddingRight+'px'}">
		<!-- <uni-grid :column="4" :highlight="true" @change="change">
				<uni-grid-item v-for="(item, index) in 4" :index="index" :key="index">
					<view class="grid-item-box" style="background-color: #fff;">
						<uni-icons type="image" :size="30" color="#777" />
						<text class="text">文本信息</text>
					</view>
				</uni-grid-item>
			</uni-grid> -->
		<div v-if="data.config.style == 2001" class="nine-grid">
			<div :style="{'background':data.config.cardBgColor}" v-for="(item, index) in data.config.data" :key="index"
				class="grid-item" @click="click(item)">
				<img :src="item.icon" style="width: 60px; height: 60px; border-radius: 10px;"></img>
				<div style="margin-top: 10px; font-size: 16px;">{{ item.title }}</div>
			</div>
		</div>
		<div v-if="data.config.style == 2003" class="two-grid">
			<div style="display: flex;" :style="{'background':data.config.cardBgColor}"
				v-for="(item, index) in data.config.data" :key="index" class="grid-item2" @click="click(item)">
				<!-- <image :src="item.icon" style="width: 50px; height: 50px;"></image>
				<view style="width: 100px;">11</view> -->

				<div class="icon-container">
					<img :src="item.icon" style="width: 50px; height: 50px; border-radius: 50%;"></img>
				</div>
				<div class="text-container">
					<p class="title">{{ item.title }}</p>
					<p class="subtitle">{{ item.subTitle }}</p>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Tpl_Menu',
		props: {
			data: {
				type: Object,
				default: () => ({})
			},
		},
		data() {
			return {

			}
		},
		methods: {
			click(item) {
				console.log(item)
				const url = item.path;
				if (url.startsWith("http")) {
					// plus.runtime.openURL(url, function(err) {
					// 	console.log("打开链接失败: " + err.message);
					// });
					window.location.href = url;
				} else {
          this.$router.push(url)
				}


			}
		}
	};
</script>

<style scoped>
	.nine-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 10px;
		padding: 10px;
	}

	.two-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 20px;
		padding: 10px;
	}

	.grid-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 0px;
	}

	.grid-item i {
		font-size: 24px;
		margin-bottom: 10px;
	}

	.grid-item p {
		margin-top: 10px;
		font-size: 16px;
	}

	.grid-item2 {
		display: flex;
		align-items: center;
		padding: 10px;
		border-radius: 8px;
		background-color: #f9f9f9;
	}

	.icon-container {
		margin-right: 15px;
	}

	.icon-container i {
		font-size: 24px;
	}

	.text-container {
		display: flex;
		flex-direction: column;
	}

	.text-container .title {
		margin: 0;
		font-size: 16px;
		font-weight: bold;
	}

	.text-container .subtitle {
		margin: 5px 0 0;
		font-size: 12px;
		color: darkgray;
	}
</style>